import React from 'react';
import ActivityLoader from '../Common/ActivityLoader';
import ajaxReport from '../../util/remote/ajaxReport';
import { Link } from 'react-router-dom';

const ReportSection = ({reports, onSelect}) => {

   const loadReport = async (reportId) => {
   
  };


    return (
        <div className="card shadow-sm">
                    <div className="card-header bg-white d-flex justify-content-between align-items-center">
                      <h6 className="mb-0 card-title">
                        <i className="fa fa-book text-primary mr-2"></i>
                        Academic Reports
                      </h6>
                    </div>
                    <div className="card-body overflow-auto" style={{ maxHeight: "40vh" }}>
                      {reports !== '404' ? (
                        <div className="list-group">
                          {Array.isArray(reports) ? reports.map(report => (
                            <div key={report.id} className="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
                              <div>
                                <Link to="#" onClick={() => onSelect(report)}>{report.title}</Link><br />
                                <small className="text-muted">{report.class.class_name} - {report.term.term} - {report.year}</small>
                              </div>
                              <span className="badge badge-light text-uppercase font-weight-bold">{report.report_format.format_name}</span>
                            </div>
                          )): <ActivityLoader />}
                        </div>
                      ) : <p className="text-muted">No academic reports available.</p>}
                    </div>
                  </div>
    );
};

export default ReportSection;